import React from "react";
import { Text } from "@mantine/core";
import {
  ReportMetricDef,
  ReportV2Definition,
  ViewConfig,
} from "../../../../types/reportsV2";
import { ViewPatch } from "../hooks/useReportDraft";
import { setSectionColumns, toggleColumn } from "./customizeRules";
import MetricChecklist from "./MetricChecklist";
import styles from "./CustomizeDrawer.module.css";

export interface ColumnsTabProps {
  definition: ReportV2Definition;
  /** Static metrics plus the latest run's payment-method columns. */
  catalog: ReportMetricDef[];
  view: ViewConfig;
  onUpdate: (patch: ViewPatch) => void;
  /** Phones: the info icons are tapped, not hovered. */
  mobile?: boolean;
}

/**
 * Columns, sectioned like the definition, with Select all / Deselect all per
 * section. Columns keep catalog order; at least one stays visible, and
 * unavailable metrics can't be turned on.
 */
export default function ColumnsTab({
  definition,
  catalog,
  view,
  onUpdate,
  mobile = false,
}: ColumnsTabProps) {
  const isChecked = (key: string) => view.columns.includes(key);
  const onlyOne = view.columns.length === 1;
  return (
    <>
      <Text className={styles.note}>
        {mobile
          ? "Pick the columns to show. Tap the info icon for how each is calculated."
          : "Pick the columns to show. Hover the info icon for how each is calculated."}
      </Text>
      <MetricChecklist
        sections={definition.metric_sections}
        metrics={catalog}
        isChecked={isChecked}
        isDisabled={(m) =>
          (!m.available && !isChecked(m.key)) || (onlyOne && isChecked(m.key))
        }
        onToggle={(key) =>
          onUpdate((v) => ({ columns: toggleColumn(v.columns, key, catalog) }))
        }
        onToggleSection={(keys, on) =>
          onUpdate((v) => ({
            columns: setSectionColumns(v.columns, keys, on, catalog),
          }))
        }
      />
    </>
  );
}
